import { useToast } from "@hightouch/htui";

/** Copies a URL, and says whether it worked. */
export function useCopyUrl() {
  const { toast } = useToast();
  return async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      toast({ id: "link-copied", variant: "success", title: "Link copied" });
    } catch (error) {
      toast({
        id: "link-copied",
        variant: "error",
        title: "Couldn't copy the link",
        message: error instanceof Error ? error.message : undefined,
      });
    }
  };
}
